import { Grid } from '@material-ui/core'
import PackPass from './PackPass'
import CaritraWidgetUnit from './Unit'
import "./Widget.css"

const getOptions = (widgetInfo, staffIndex) => {
    if(widgetInfo.widgetView === 'Group'){
        return {
            pack_pass:widgetInfo.pricingOptionDetails.filter(option => option.type !== "Unit"),
            units: widgetInfo.pricingOptionDetails.filter(option => option.type === "Unit")
        }
    }
    else if(widgetInfo.widgetView === 'Private' && ![null, undefined].includes(staffIndex)){
        return {
            pack_pass:widgetInfo.staffDetails[staffIndex].pricingOptionDetails.filter(option => option.type !== "Unit"),
            units: widgetInfo.staffDetails[staffIndex].pricingOptionDetails.filter(option => option.type === "Unit")
        }
    }
    else{
        return {}
    }
}



const CaritraWidget = (props) => {
    const { widgetInfo, setError, staffIndex } = props
    const {pack_pass, units} = getOptions(widgetInfo, staffIndex)
    const staff = ![null, undefined].includes(staffIndex)?widgetInfo.staffDetails[staffIndex]:undefined;
    const redirectURL = `${widgetInfo.sourceURL}/Market-Place`
    if (Array.isArray(pack_pass) || Array.isArray(units)) {
        return (
            <Grid
                container
                className="CaritraWidgetContainer"
                style={{
                    backgroundColor: widgetInfo.widgetColor.backgroundColor
                }}>
                {pack_pass.map((option, index) => (
                    <Grid item xs={12} key={`pack_pass_${index}_${staff ? staff.firstName + "_" + staff.lastName : ""}`}>
                        <PackPass
                            {...{ option, staff, widgetInfo, packpassIndex: index, redirectURL }}
                        />
                    </Grid>
                ))}
                {units.map((option, index) => (
                    <Grid item xs={12} key={`unit_${index}_${staff ? staff.firstName + "_" + staff.lastName : ""}`}>
                        <CaritraWidgetUnit
                            {...{ option, staff, widgetInfo, unitIndex: index, setError, redirectURL }}
                        />
                    </Grid>
                ))}


            </Grid>
        )
    }
    else {
        setError("The widget data provided is broken. Please contact Caritra.")
        return null
    }
}

export default CaritraWidget